import { apiClient } from "./api";

export interface WorkspaceFile {
  path: string;
  size: number;
  modified_at: number;
}

export interface Workspace {
  id: string;
  name: string;
  path: string;
  created_at: number;
}

export async function createWorkspace(name: string): Promise<Workspace> {
  const response = await apiClient.post("/workspaces", { name });
  return response.data;
}

export async function listFiles(workspaceId: string): Promise<WorkspaceFile[]> {
  const response = await apiClient.get(`/workspaces/${workspaceId}/files`);
  return response.data;
}

export async function readFile(workspaceId: string, filePath: string): Promise<string> {
  const response = await apiClient.get(`/workspaces/${workspaceId}/files/${encodeURIComponent(filePath)}`);
  return response.data;
}

export async function writeFile(workspaceId: string, filePath: string, content: string): Promise<WorkspaceFile> {
  const response = await apiClient.put(`/workspaces/${workspaceId}/files/${encodeURIComponent(filePath)}`, { content });
  return response.data;
}

export async function deleteFile(workspaceId: string, filePath: string): Promise<void> {
  await apiClient.delete(`/workspaces/${workspaceId}/files/${encodeURIComponent(filePath)}`);
}
